import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'
import Input from '../../Form/Input'
import Button from '../../Form/Button'
import Loader from '../../Loader'
import { withTranslation } from 'react-i18next'
import { createWinlineId } from '../../../../api'

class WinlineId extends PureComponent {

  state = {
    loading: false
  }
  abortController = null

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onGenerateClick = () => {
    if(this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true }, async () => {
      try {
        const response = await createWinlineId(this.props.customerId, this.abortController).fetchPromise
        this.setState({ loading: false })
        this.props.onChange(parseInt(response.id, 10))
      } catch (e) {
        if (this.abortController.signal.aborted) {
          return
        }
        console.error(e)
        this.setState({ loading: false })
      }
    })
  }

  onInputChange = (event) => {
    let value = event.target.value
    if (event.target.value !== '') {
      value = parseInt(value, 10)
    }
    this.props.onChange(value)
  }

  render () {
    const { t } = this.props
    let append
    if (!this.props.value) {
      append = <Button style={{marginLeft: '10px'}} classNames={'Button-Rounded-Side'} onClick={this.onGenerateClick}>{t('GENERATE')}</Button>
    }
    return (
      <div>
        {this.state.loading && <Loader size={32}/>}
        <Input value={this.props.value} label={'Winline-ID'}
               required={this.props.required}
               append={append}
               onChange={this.onInputChange}
               round={this.props.round}
        />
      </div>
    )
  }
}
WinlineId.defaults = {
  required: false
}
WinlineId.propTypes = {
  customerId: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  required: PropTypes.bool,
  round: PropTypes.bool
}
export default withTranslation()(WinlineId)
